import { BlockError } from '@root/@types/types';

export const blockErrorMessages = {
  [BlockError.BlockEmpty]:
    'There are blank blocks in the contract. Please ensure all blocks are complete before proceeding.',
  [BlockError.DatapointEmpty]:
    'There are incomplete blocks in the contract. Please ensure all blocks are complete before proceeding.',
  [BlockError.VariationNotSelected]:
    'There are unselected block variations in the contract. Please ensure all variations have been selected before proceeding.',
  [BlockError.UnresolvedComments]:
    'There are unresolved comments on the contract. Please ensure all comments are resolved before proceeding.',
};

export const blockErrorValidationSuccessMessages = {
  [BlockError.BlockEmpty]: 'No blank blocks are present in the contract.',
  [BlockError.DatapointEmpty]: 'All blocks are complete in the contract.',
  [BlockError.VariationNotSelected]: 'All block variations are set in the contract.',
  [BlockError.UnresolvedComments]: 'All comments are resolved on the contract.',
};
